import CameraTableRow from "./CameraTableRow";

export default CameraTableRow;
